import { api } from "./api";
import axios from "axios";

async function resendEmail(): Promise<void> {
  await api.post("/v1/authentication/email/verification-notification", {});
}

async function getVerification(url: string): Promise<void> {
  return await axios.get(url);
}
export const EmailService = { resendEmail, getVerification };
